import { UserProfile } from '@/types/users'
import { computed, ComputedRef } from '@vue/composition-api'

const useBatteryStatus = (profile: ComputedRef<UserProfile|null>) => {
  const chargingStatus = computed(() => {
    if (profile?.value?.isBatteryCharging === undefined) return 'Unknown'
    return profile.value?.isBatteryCharging ? 'Charging' : 'Not Charging'
  })
  const percentBattery = computed(() => {
    if (profile.value?.batteryLevel === null || profile.value?.batteryLevel === undefined) return 'N/A'
    return `${ Math.round(profile.value.batteryLevel) }%`
  })

  return {
    chargingStatus,
    percentBattery
  }
}

export default useBatteryStatus
